import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mvit-tags" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = ["type", "placeholder"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (tag) => {
        return (_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn btn-sm btn-secondary mb-2 me-2",
          key: tag,
          onClick: ($event: any) => (_ctx.removeTag(tag))
        }, _toDisplayString(tag), 9, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: _ctx.type || 'url',
        ref: "mvit",
        step: "0",
        min: "0",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mvitValue) = $event)),
        class: "form-control",
        placeholder: _ctx.placeholder || 'e.g. https://example.com',
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.typing && _ctx.typing(...args)))
      }, null, 40, _hoisted_4), [
        [
          _vModelDynamic,
          _ctx.mvitValue,
          void 0,
          { trim: true }
        ]
      ]),
      (_ctx.links && _ctx.links.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.links.splice(0, _ctx.links.length)))
          }, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}